<template>
  <div class="blog-post-item w-dyn-item">
    <div class="dynamic-item-wrapper">
      <div
        class="dynamic-post-image"
        :style="backgroundImage"
      >
        <div class="blog-post-date-overlay">
          <BaseDate :date="post.published_at" />
        </div>
      </div>
      <div class="dynamic-item-content-block">
        <router-link
          :to="{ name: 'BlogPost', params: { slug: post.slug }}"
          class="blog-post-link-title"
        >
          {{ post.title }}
        </router-link>
        <p>
          {{ post.preview }}
        </p>
        <router-link
          :to="{ name: 'BlogPost', params: { slug: post.slug }}"
          class="learn-more link"
        >
          Read more
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    post: {
      required: true,
      type: Object,
    },
  },
  computed: {
    backgroundImage() {
      return {
        // eslint-disable-next-line
        'background-image': `url('${this.imagePath()}')`,
      }
    },
  },
  methods: {
    imagePath() {
      // eslint-disable-next-line
      return require(`../assets/article_photos/${this.post.image}`)
    },
  },
}
</script>
